import { useContext, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useInstanceSelector } from '@s20/hooks/redux.hooks';
import { checkUserHasPermission } from '@s20/selectors/features/permissions.selectors';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../../Common';
import { FormContext } from '../../../common/forms/FormElements';
import ValidatedSelect from '../../../common/forms/ValidatedSelect';
import { CustomerForm } from './CustomerForm';

export const Customer = ({ disabled }) => {
    const { setFieldValue } = useContext(FormContext);

    const [showSlideForm, setShowSlideForm] = useState(false);

    const { data, isLoading } = useQuery({
        queryKey: ['customers'],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.customers()),
    });

    const hasEditPermission = useInstanceSelector(checkUserHasPermission, 'company.create');

    return (
        <>
            <ValidatedSelect
                id="companyId"
                name="companyId"
                options={data}
                label="Which customer is this job for?"
                required
                error="You must select a customer for this job"
                showAddButton={!disabled && hasEditPermission}
                isLoading={isLoading}
                onAddButtonClick={() => setShowSlideForm(true)}
                disabled={disabled}
                onChange={(value) => {
                    setFieldValue('isIntercompanyCustomer', value?.isIntercompany ?? false);
                    setFieldValue('contractId', null);
                }}
            />

            <CustomerForm
                show={showSlideForm}
                setShowSlideForm={setShowSlideForm}
            />
        </>
    );
};